var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendarWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Fill 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8048128,2.00046215 L12.5289704,2.00046215 L12.5289704,0.75 L11.6788864,0.75 L11.6788864,2.00046215 L4.87821447,2.00046215 L4.87821447,0.75 L4.02813048,0.75 L4.02813048,2.00046215 L2.75372082,2.00046215 C1.58202851,2.00046215 0.627740084,2.93500273 0.627740084,4.08415099 L0.627740084,13.6663113 C0.627740084,14.8146953 1.5812487,15.75 2.75372082,15.75 L13.8049035,15.75 C14.9765958,15.75 15.9308842,14.8154596 15.9308842,13.6663113 L15.9301751,6.16641789 L15.9301751,4.08272904 C15.9294678,2.93434508 14.9759592,2.00046215 13.8049198,2.00046215 L13.8048128,2.00046215 Z M14.8169687,13.5443889 C14.8169687,14.2065853 14.2673404,14.7452799 13.5917036,14.7452799 L2.96668403,14.7452799 C2.28968731,14.7452799 1.74004157,14.2065853 1.74004157,13.5443889 L1.74004157,6.53831063 L14.8169687,6.53831063 L14.8169687,13.5443889 Z M14.8169687,5.43547979 L1.74015038,5.43547979 L1.74015038,4.23324239 C1.74015038,3.57038153 2.28977704,3.03100498 2.96678917,3.03100498 L4.19342796,3.03100498 L4.19342796,3.83204658 L5.00936803,3.83204658 L5.00936803,3.03233791 L11.5477685,3.03233791 L11.5477685,3.83337951 L12.3650685,3.83337951 L12.3650685,3.03233791 L13.5917073,3.03233791 C14.267342,3.03233791 14.8169687,3.57036444 14.8169687,4.2332253 L14.8169687,5.43547979 Z",
    id: "Fill-1",
    fill: "#ffffff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarWhite);
export default __webpack_public_path__ + "static/media/calendar-white.fa80c139.svg";
export { ForwardRef as ReactComponent };